import type { DeviceRPi } from "luxedo-data"
import { NetworkTestController } from "./NetworkTestController"

export const openNetworkTestOverlay = NetworkTestController.open
